module.exports = __webpack_public_path__ + "shifter.png?7aeb5ac3f0b92b3d3f487166149943a4";